import { render, staticRenderFns } from "./work_edit.vue?vue&type=template&id=0b87c9e0&scoped=true"
import script from "./work_edit.vue?vue&type=script&lang=js"
export * from "./work_edit.vue?vue&type=script&lang=js"
import style0 from "./work_edit.vue?vue&type=style&index=0&id=0b87c9e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87c9e0",
  null
  
)

export default component.exports